import { render, staticRenderFns } from "./DesignEditor.vue?vue&type=template&id=d84bcbea&scoped=true&"
import script from "./DesignEditor.vue?vue&type=script&lang=js&"
export * from "./DesignEditor.vue?vue&type=script&lang=js&"
import style0 from "./DesignEditor.vue?vue&type=style&index=0&id=d84bcbea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84bcbea",
  null
  
)

export default component.exports